import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubaccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_42780_4197)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.368 10.5534C16.3677 10.625 16.3919 10.6944 16.4365 10.7505L17.3858 11.9395C17.5575 12.1532 17.6604 12.4134 17.6809 12.6862C17.7016 12.9589 17.639 13.2315 17.5014 13.4684L16.9449 14.4261C16.8076 14.6631 16.6016 14.8535 16.3538 14.9723C16.106 15.091 15.828 15.1328 15.556 15.092L14.044 14.8633C13.9724 14.8533 13.8996 14.8671 13.8369 14.9025L12.0453 15.931C11.983 15.9673 11.9347 16.0234 11.908 16.0902L11.3502 17.5054C11.2504 17.7597 11.0757 17.9782 10.849 18.1324C10.6224 18.2865 10.3542 18.3691 10.0796 18.3696H8.96654C8.69192 18.3691 8.42379 18.2865 8.19712 18.1324C7.97045 17.9782 7.79578 17.7597 7.6959 17.5054L7.13809 16.0902C7.11139 16.0234 7.06312 15.9673 7.00086 15.931L5.20926 14.9025C5.14648 14.8669 5.07366 14.8532 5.00215 14.8633L3.4901 15.092C3.21812 15.1328 2.94007 15.091 2.69231 14.9723C2.44454 14.8535 2.23857 14.6631 2.1013 14.4261L1.54477 13.4684C1.40714 13.2315 1.34455 12.9589 1.36518 12.6862C1.38581 12.4134 1.48869 12.1532 1.66039 11.9395L2.61464 10.7505C2.65929 10.6944 2.68348 10.625 2.68325 10.5534V8.4964C2.68348 8.42487 2.65929 8.35538 2.61464 8.2993L1.66039 7.11032C1.48869 6.89662 1.38581 6.6364 1.36518 6.36364C1.34455 6.09089 1.40714 5.81828 1.54477 5.58146L2.1013 4.62371C2.23857 4.38668 2.44454 4.19633 2.69231 4.07754C2.94007 3.95874 3.21812 3.91703 3.4901 3.95783L4.99834 4.18654C5.06983 4.19661 5.14267 4.18284 5.20545 4.14737L7.00086 3.11381C7.06312 3.07737 7.11139 3.02135 7.13809 2.95461L7.69845 1.54451C7.79832 1.29014 7.973 1.07161 8.19967 0.917438C8.42632 0.763268 8.69446 0.680616 8.96907 0.680267H10.0847C10.3593 0.680616 10.6274 0.763268 10.8541 0.917438C11.0808 1.07161 11.2554 1.29014 11.3553 1.54451L11.9131 2.95461C11.9389 3.02323 11.9872 3.08114 12.0504 3.11886L13.8419 4.14737C13.9048 4.18275 13.9776 4.19652 14.049 4.18654L15.5611 3.95783C15.8331 3.91703 16.1112 3.95874 16.359 4.07754C16.6066 4.19633 16.8126 4.38668 16.9499 4.62371L17.5065 5.58146C17.644 5.81828 17.7066 6.09089 17.6861 6.36364C17.6654 6.6364 17.5625 6.89662 17.3908 7.11032L16.4365 8.2993C16.3919 8.35538 16.3677 8.42487 16.368 8.4964V10.5534Z",
				stroke: "currentColor",
				strokeWidth: 1.36071,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.40234 12.9025C7.26785 12.2397 8.35023 11.8458 9.52461 11.8458C10.699 11.8458 11.7814 12.2397 12.6469 12.9025",
				stroke: "currentColor",
				strokeWidth: 1.36071,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.52552 9.75952C10.9169 9.75952 11.6995 8.97691 11.6995 7.58558C11.6995 6.19425 10.9169 5.41162 9.52552 5.41162C8.13419 5.41162 7.35156 6.19425 7.35156 7.58558C7.35156 8.97691 8.13419 9.75952 9.52552 9.75952Z",
				stroke: "currentColor",
				strokeWidth: 1.36071,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_42780_4197",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19.05,
			height: 19.05,
			fill: "white"
		})
	}) })]
});
export default SvgSubaccount;
